"use strict";
/*
  Vereign Seal integration library. Copyright (C) 2020-2021 Vereign AG

  This program is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General
  Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option)
  any later version.

  This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied
  warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
  details.

  You should have received a copy of the GNU Affero General Public License along with this program. If not, see
  https://www.gnu.org/licenses/.

  In case of queries or questions, please contact us under by email under contact@vereign.com or by letter post to
  Vereign AG, Kolinplatz 10, 6300 Zug, Switzerland
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CryptoServiceNode_1 = __importDefault(require("./CryptoServiceNode"));
const CryptoServiceWeb_1 = __importDefault(require("./CryptoServiceWeb"));
const service = typeof crypto !== "undefined" && crypto.subtle
    ? CryptoServiceWeb_1.default
    : CryptoServiceNode_1.default;
exports.default = service;
